<template>

  <div id="academy_kat">

    <div class="c-img-bg c-academy-bg">

      <div class="container-xl">
        <div class="row">
          <div class="col-12">

            <!-- navigation-->
            <Navi dark-mode></Navi>

            <!-- happiness & work - tools -->  
            <div class="row justify-content-center">
              <div class="col-11 coll-md-10">
                <div class="row align-items-end">
                  <div class="col-12 order-1 col-md-12 order-md-1 py-3 align-self-start">             
                    <p class="c-txt-orange" style="font-weight: bold;">Material zum Downlaod</p>  
                    <h2 class="text-center text-md-center c-h2" >Wissen & Tools</h2>
                  </div>
                  <div class="col-12 order-2 col-md-6 order-md-2 align-self-center">
                    <img id="bubble_hho" src="@/assets/academy_tools.png" alt="HappinessAndWork_Tools">
                  </div>
                  <div class="col-12 order-3 col-md-6 order-md-3 py-3 align-self-start"> 
                    <p class="text-center text-md-left">
                        Hier haben wir euch einige Dinge zusammengestellt, die ihr für Artikel, Blogs und Post gebrauchen könntet. 
                        Wir freuen uns über Kommentare in den Sozialen Medien und eure Fragen. Ihr braucht mehr? Bekommt ihr! 
                    </p>
                    <!-- contact -->
                    <div class="d-flex justify-content-left">  
                      <!-- button -->
                      <a :href="`mailto:info@happinessandwork.de?subject=${emailSubject}&body=${emailBody}`">
                        <div class="c-btn c-btn-orange" >
                          <span style="padding: 10px">Schreib uns</span>
                          <div class="c-btn-img c-btn-img-right-white"/>
                        </div>
                      </a>
                    </div>
                    <!-- HAW scale -->
                    <p class="text-left">
                      <br/>
                      Einsatz der HappinessandWork-Scale in Training, Workshops & Teamentwicklung
                    </p>       
                    <ul class="text-left">
                      <li><a href="/downloads/HappinessAndWork_WorkshopTemplate.pdf" download="HappinessAndWork_WorkshopTemplate.pdf">HappinessAndWork-Scale Vorlage [PDF]</a></li>
                    </ul>
                    <!-- books -->
                    <p class="text-left">
                      Bücher & Reports
                    </p>       
                    <ul class="text-left">
                      <li><router-link to="/haw/happiness_and_work_report" style="text-decoration: none">Happiness & Work Report</router-link></li>
                      <li><router-link to="/haw/books" style="text-decoration: none">Bücher</router-link></li>
                    </ul>
                    <!-- Logos -->
                    <p class="text-left">
                      Logos
                    </p>       
                    <ul class="text-left">
                      <li><a href="/downloads/happiness_logo_white.png" download="HappinessAndWork_Logo-white.png">Happiness & Work Logo (white) [PNG]</a></li>
                      <li><a href="/downloads/happiness_logo_white.svg" download="HappinessAndWork_Logo-white.svg">Happiness & Work Logo (white) [SVG]</a></li>
                      <li><a href="/downloads/happiness_logo_orange.png" download="HappinessAndWork_Logo-orange.png">Happiness & Work Logo (orange) [PNG]</a></li>
                      <li><a href="/downloads/happiness_logo_orange.svg" download="HappinessAndWork_Logo-orange.svg">Happiness & Work Logo (orange) [SVG]</a></li>
                    </ul>
                    <!-- Diagramme -->
                    <p class="text-left">
                      Diagramme
                    </p>       
                    <ul class="text-left">
                      <li><a href="/downloads/happiness_overall.png" download="HappinessAndWork_Glueck_im_Unterehmen.png">Glück in Unternehmen</a></li>
                      <li><a href="/downloads/happiness_gender.png" download="HappinessAndWork_Glueck_und_Geschlecht.png">Glück & Geschlecht</a></li>
                      <li><a href="/downloads/happiness_education.png" download="HappinessAndWork_Glueck_und_Bildung.png">Glück & Bildung</a></li>
                      <li><a href="/downloads/happiness_industrial_sector.png" download="HappinessAndWork_Glueck_und_Branche.png">Glück & Branche</a></li>
                      <li><a href="/downloads/happiness_company_size.png" download="HappinessAndWork_Glueck_und_Unternehmensgroesse.png">Glück & Unternehmensgröße</a></li>
                      <li><a href="/downloads/happiness_salary.png" download="HappinessAndWork_Glueck_und_Gehalt.png">Glück & Gehalt</a></li>
                    </ul>  
                    <p class="text-left">
                      Portraits - Ricarda Rehwaldt
                    </p>       
                    <ul class="text-left">
                      <li><a href="/downloads/Portrait_Rehwaldt_1.jpg" download="Portrait_Rehwaldt_1.jpg">Portrait 1 (4405 x 4405)</a></li>
                      <li><a href="/downloads/Portrait_Rehwaldt_2.jpg" download="Portrait_Rehwaldt_2.jpg">Portrait 2 (4931 x 2913)</a></li>
                      <li><a href="/downloads/Portrait_Rehwaldt_2_Ausschnitt.jpg" download="Portrait_Rehwaldt_2_Ausschnitt.jpg">Portrait 2 Ausschnitt (1520 x 1484)</a></li>
                      <li><a href="/downloads/Portrait_Rehwaldt_3.jpg" download="Portrait_Rehwaldt_3.jpg">Portrait 3 (4480 x 4480)</a></li>
                      <li><a href="/downloads/Portrait_Rehwaldt_3_Ausschnitt.jpg" download="Portrait_Rehwaldt_3_Ausschnitt.jpg">Portrait 3 Ausschnitt (2291 x 1906)</a></li>
                    </ul>              
                  </div>
                </div> 
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- wave bottom -->
      <div class="c-wave c-wave-bottom"/>
    </div>

    <!-- footer -->
    <div class="c-orange-bg">   
      <!-- wave top -->
      <div class="c-wave c-wave-top" style="position: relative; top:-2px;"/>
      <!-- footer content -->
      <div class="container-xl">
        <div class="row c-txt-white c-footer">
          <div class="col-12">
            <Footer></Footer>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Navi from '@/components/Navi.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Academy_KAT',
  components: {
    Navi,
    Footer
  },
  metaInfo() {
    // patch meta data on current page
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: `${this.metaTitle}`,
      meta: [
        { vmid: "keywords",  name: 'keywords', content: `${this.metaKeywords}` },
        { vmid: "description", name: 'description', content: `${this.metaDescription}`},
        // social tagging
        { vmid: "og:title", property: "og:title", content: `${this.metaTitle}` },
        { vmid: "og:url", property: "og:url", content: `${this.metaUrl}` },
        { vmid: "og:description", property: "og:description", content: `${this.metaDescription}` },
        { vmid: "og:image", name: 'og:image', content: `${this.metaImage}` }
      ]
    }
  },
  data() {
    return {
      // email data
      emailSubject: "HAW Anfrage - Academy - Wissen %26 Tools",
      emailBody: "Guten Tag,%0A%0Aich bin auf der Website www.happinessandwork.de auf euer Angebot aufmerksam geworden.%0AIch interessiere mich insbesondere für 'Academy - Wissen %26 Tools'.%0AIch würde gern diesbezüglich kontaktiert werden - Tel: [meine_telefonnummer]%0A%0AVielen Dank",
      // metaData
      metaTitle: "- Academy - Wie schafft es eine Organisation, dass ihre Mitarbeiter glücklich sind?",
      metaDescription: "Wie schafft es eine Organisation, dass ihre Mitarbeiter glücklich sind? Die Felicicon GmbH hat Weiterbildungsangebote für Mitarbeiter und Führungskräfte und führen in Mitarbeiter Events in das Thema ein.",
      metaUrl: "/academy/happiness_and_homeoffice",
      metaKeywords: "Seminar Beratung Coaching Teamentwicklung Keynotes Homeoffice 'Happinessandwork Academy'",
      metaImage: "https://www.happinessandwork.de/share/academy.png",
      // eventbride
      eventbriteCourse1 : [
        //{date: '10. - 12. September 2020', eventId: '116082992355', visible: false},
        //{date: '12. - 14. November 2020', eventId: '116977666349', visible: false},
        //{date: '04. - 06. März 2021', eventId: '116981273137', visible: false},
        //{date: '10. - 12. Juni 2021', eventId: '129660007573', visible: false},
        //{date: '11. - 13. November 2021', eventId: '129660751799', visible: false}
        //{date: '11. - 13. Juni 2021', eventId: '98193488367', visible: false}
      ],
      eventbriteCourse2 : [
        //{date: '10. - 12. Februar 2021', eventId: '116978400545', visible: false},
        //{date: '05. - 07. Mai 2021', eventId: '116980954183', visible: false}
      ],
      eventbriteCourse3 : [
        //{date: '02. Oktober 2020', eventId: '116981874937', visible: false},
        //{date: '27. November 2020', eventId: '116982342335', visible: false}
      ],
      eventbriteLoaded: false   // status of eventbrite script loading
    }
  },
  // called when component is mounted to the dom
  mounted: function () {
    // load js code from eventbrite
    const eventbriteScript = 'https://www.eventbrite.de/static/widgets/eb_widgets.js'
    this.$loadScript(eventbriteScript)
      .then(() => {
        // Script is loaded
        let eb = {
          // Required
          widgetType: 'checkout',
          eventId: null,
          iframeContainerId: null,
          // Optional
          iframeContainerHeight: 450,  // Widget height in pixels. Defaults to a minimum of 425px if not provided
          onOrderComplete: this.orderCompletedCallback  // Method called when an order has successfully completed
        }
        // prepare iframes for course 1
        this.eventbriteCourse1.forEach((course) => {
          eb.eventId = course.eventId;
          eb.iframeContainerId = 'eventbrite-widget-container-' + course.eventId,
          // create Iframes
          window.EBWidgets.createWidget(eb)
        })
        // prepare iframes for course 2
        this.eventbriteCourse2.forEach((course) => {
          eb.eventId = course.eventId;
          eb.iframeContainerId = 'eventbrite-widget-container-' + course.eventId,
          // create Iframes
          window.EBWidgets.createWidget(eb)
        })
        // prepare iframes for course 3
        this.eventbriteCourse3.forEach((course) => {
          eb.eventId = course.eventId;
          eb.iframeContainerId = 'eventbrite-widget-container-' + course.eventId,
          // create Iframes
          window.EBWidgets.createWidget(eb)
        })
        // stop spinner
        this.eventbriteLoaded = true
      })
      .catch(() => {
        // Failed to fetch script
        console.log('Failed to load eventbrite script: ' + eventbriteScript); // eslint-disable-line no-console
      });
  },
  methods: {
    // called when order complete
    orderCompletedCallback() {
      console.log('Order complete!'); // eslint-disable-line no-console
      // send event to analytics
      this.$gtag.event('complete', {
        event_category: 'order',
        event_label: 'Academy',
        value: 123
      })
      /*
      this.$ga.event({
        eventCategory: 'order',
        eventAction: 'complete',
        eventLabel: 'Academy',
        eventValue: 123
      })
      */
    }
  }
}

</script>

<style>

</style>
